
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class InvoiceCompanyGrid extends Serenity.EntityGrid<InvoiceCompanyRow, any> {
        protected getColumnsKey() { return InvoiceCompanyColumns.columnsKey; }
        protected getDialogType() { return InvoiceCompanyDialog; }
        protected getIdProperty() { return InvoiceCompanyRow.idProperty; }
        protected getInsertPermission() { return InvoiceCompanyRow.insertPermission; }
        protected getLocalTextPrefix() { return InvoiceCompanyRow.localTextPrefix; }
        protected getService() { return InvoiceCompanyService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}